// this is the max number of rows MUI DataGrid will display
export const MAXIMUM_ROW_COUNT = 200;

export enum PageSizes {
  Five = 5,
  Ten = 10,
  Twenty = 20,
  Thirty = 30,
  Fifty = 50,
  FiveHundred = 500,
}
